import { FC } from 'react';

import Callout from 'components/_core/Callout';

import locales from './locales';
import { BeneficiaryInviteeButtonProps } from './types';

const BeneficiaryInviteeButton: FC<BeneficiaryInviteeButtonProps> = ({
  onClick,
}) => (
  <Callout>
    <Callout.Content>{locales.description}</Callout.Content>
    <Callout.Button onClick={onClick}>{locales.actionText}</Callout.Button>
  </Callout>
);

export default BeneficiaryInviteeButton;
